<template>
  <b-container class="futureIT my-5">

    <sectionHeader class="py-3" :text="header"></sectionHeader>
    <sectionSummary
      :text="summary">
    </sectionSummary>

    <b-row>
      <b-col sm="12" md="8" offset-md="2">
        <div class="text">
          <p>{{text}}</p>
        </div>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import sectionHeader from '../text/SectionHeader'
import sectionSummary from '../text/SectionSummary'
const SECTIONID = 4

export default {
  name: 'futureIT',
  props: ['language'],
  components: {
    sectionHeader,
    sectionSummary,
  },
  data () {
    return {
      header: '',
      summary: '',
      text: '',
      cite: ''
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.header = this.$root.getHeader(SECTIONID)
      this.summary = this.$root.getSummary(SECTIONID)
      this.text = this.$root.getText(SECTIONID)
      switch (this.$root.getLanguage()) {
        case 'SE':
          this.cite = ' Dynalab'
          break
        case 'EN':
          this.cite = ' Dynalab'
          break
      }
    }
  }
}

</script>

<style scoped>

.futureIT {
  width: 100%;
  /*background: url("./assets/Test.jpg") 0% 20% no-repeat;*/
}

@media (max-width: 600px) {
  .futureIT {
    /*background: url("./assets/Test.jpg") 0% 50% no-repeat;*/
  }
}

.futureIT .text {
  text-align: center;
  font-weight:300;
}

</style>



// WEBPACK FOOTER //
// src/components/start/FutureIT.vue